<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container d-flex flex-column h-full">
                    <TopAppBar
                        :leftBtnMode="leftBtnMode"
                        :rightBtnMode="rightBtnMode"
                        :title="title"
                        :leftBtnMethod="leftBtnMethod"
                        :rightBtnMethod="rightBtnMethod"
                        staticMode="true"
                    >
                    </TopAppBar>
                    

                    <div class="sm_wrap">
                        <div class="sign_wrap">
                            <h2>{{$t('836')}}</h2>
                            <p class="sign_tail">{{$t('837')}}</p>
                            
                            <div class="sign_box">
                                <dl class="sign_dl active">
                                    <dt>{{$t('838')}}</dt>
                                    <dd>
                                        {{$t('839')}}
                                        <br />
                                        {{$t('840')}}
                                        <br/>
                                        {{$t('841')}}
                                    </dd>
                                </dl>
                                <dl class="sign_dl ">
                                    <dt>{{$t('842')}}</dt>
                                    <dd>
                                        {{$t('843')}}<br/>
                                        {{$t('844',{str:' support@brand.com ' })}}<br/>
                                        {{$t('845')}}
                                        <br />
                                        <div class="support">
                                            <p>{{$t('846',{str:' support@brand.com ' })}}</p>
                                            <!--  : <a href="mailto:support@brand.com">support@brand.com</a> : <a href="tel:02-9182-7364">02-9182-7364</a>-->
                                            <p>{{$t('847',{str:'02-9182-7364' })}} </p>
                                        </div>
                                    </dd>
                                </dl>
                                <dl class="sign_dl ">
                                    <dt>{{$t('848')}}</dt>
                                    <dd>
                                        {{$t('849')}}
                                        <br />
                                        {{$t('850')}}
                                        <br />
                                        {{$t('851')}}
                                        <br />
                                        <div class="support">
                                            <p>{{$t('852',{str:' support@brand.com ' })}} </p>
                                            <p>{{$t('853',{str:'02-9182-7364' })}} </p>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            
                            <div class="sign_btn">
                                <p><router-link to="/login" class="mdc-button mdc-button--raised btn-blue w-full btn-big" style="background-color:#2d6dcc">{{$t('854')}}</router-link></p>
					<p><button type="button" style="background-color:#cdd2d8" @click="resend" class="mdc-button mdc-button--raised btn-white w-full btn-big">{{$t('855')}}</button></p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div class=" pda-default">
                        <button class="mdc-button mdc-button--raised btn-red mr8" @click="$router.go(-1)">
                            {{$t('1607')}}
                            
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import joinApi from '@/api/joinApi.js'
import memberApi from '@/api/memberApi.js'

export default {
    components: {
        TopAppBar
    },
    data() {
        return {
            // title: '개인정보 보호정책',
            title: this.$t('1601'),
            htmlPrivacypolicy: null
        }
    },
    mixins: [topAppBarMixin],
    mounted() {
		$(function(){
				$(".sign_dl dt").click(function(){
					$(this).parent("dl").toggleClass("active");
				});
			});
			
        this.setTopAppBarCloseOnly(localStorage.getItem('brandName'))

        // 약관정보 API 호출(call api Privacy Policy )
        memberApi.emailVarification({"authType" : "EMAIL"}).then((response) => {
            //console.log(response.data.data)
         
        }).catch((err) => {
        })

        // 약관정보 API 호출(call api Privacy Policy )
        joinApi.terms().then((response) => {
            // console.log(response.data.data)
            const termsUrl = response.data.data.TERMS_OF_SERVICE;
            const privacyUrl = response.data.data.PRIVACY_STATEMENT;

            joinApi.policyContents(privacyUrl,'text').then((response) => {
                this.htmlPrivacypolicy = response.data
            })            
        }).catch((err) => {
        })
    },
    methods:{
        resend(){
            memberApi.emailVarification({"authType" : "EMAIL"}).then((response) => {
                this.$alert({
                        title: "Success", //가입 승인 대기 상태입니다.
                        content: 'Success ',
                        accept:  this.$t('783')
                    }).then(() => {}).catch(() => {})
            
            }).catch((err) => {
            })
        }
    }

}
</script>
<style scoped>
    .terms{position:relative; color:#333; font-size:13px; font-family:inherit; margin:0; padding:0}
    .terms *{margin:0; padding:0}
    .terms ul, .terms li{list-style:none;}
    .terms h2{font-size:16px; font-weight:bold; padding:0 0 20px 0}
    .terms div, .terms p, .terms ul{line-height:1.4}
    .terms .txt{font-size:13px; padding:5px 0}
    .terms .tit{font-size:14px; font-weight:bold; padding:15px 0 5px 0}
    .terms ul{position:relative; padding-left:20px}
    .terms ul li{padding:0 0 5px 0}
    
	.sign_wrap{position:relative; padding:15px 15px 75px 15px; background:#fff}
		.sign_wrap > h2{font-size:22px; font-weight:bold; color:#212121}
		.sign_wrap .sign_tail{position:relative; padding:5px 0 0 0; color:#818181; font-size:14px}
		.sign_box{position:relative; box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.26); border-radius:4px; margin-top:15px}
		.sign_dl{position:relative; border-bottom:1px solid rgba(172, 180, 190, 0.7);}
		.sign_dl dt{padding:15px; color:#212121; font-size:14px; font-weight:500; cursor:pointer}
		.sign_dl dt:after{content:''; width:24px; height:24px; display:inline-block; background:url(../../assets/open_bullet.png) center center no-repeat; position:absolute; right:15px; top:14px; background-size:18px auto !important}
		.sign_dl dd{position:relative; padding:15px; color:#818181; font-size:14px; line-height:1.57; overflow:hidden; display:none}
		.sign_dl.active dd{height:auto; display:block}
		.sign_dl.active dt:after{background:url(../../assets/close_bullet.png) center center no-repeat;}
		.sign_dl .support{position:relative; padding:15px 0 0 0; color:#818181}
		.sign_dl .support p{position:relative; margin-bottom:5px; color:#818181}
		.sign_dl .support p:nth-last-child(1){margin-bottom:0}
		.sign_dl .support a{color:#80aed4; text-decoration:underline}
		.sign_btn{position:relative; padding:40px 0 0 0;}
		.sign_btn > p{position:relative; margin-bottom:10px}
		.sign_btn > p:nth-last-child(1){margin-bottom:0}
		.sign_btn a{display:block; background:#cdd2d8; color:#fff; font-size:14px; text-align:center; padding:15px 10px; border-radius:4px; box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.16);}
		.sign_btn a.on{background:#2d6dcc}
		.sign_pop{position:fixed; left:10px; bottom:15px; width:calc(100% - 20px); padding:15px; color:#fff; font-size:14px; border-radius:4px; box-shadow:0 3px 5px 0 rgba(0, 0, 0, 0.26); background:#000; box-sizing:border-box}
        
</style>
